import { Dropdown, ToolbarMode, typeSearchPlaceholder, useHazardsStore } from '@/features';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useToolbarStore = defineStore('toolbarStore', () => {
  const toolbarMode = ref(ToolbarMode.None);
  const hazardsStore = useHazardsStore();

  const dropdown = computed<Dropdown | undefined>(() => {
    if (toolbarMode.value === ToolbarMode.None) return undefined;

    return {
      [ToolbarMode.Filters]: {
        placeholder: typeSearchPlaceholder,
        sections: hazardsStore.typeSections,
      },
      [ToolbarMode.Overlays]: undefined,
    }[toolbarMode.value];
  });

  return { toolbarMode, dropdown };
});
